
import XImg from 'vux/src/components/x-img/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
export default {
components: {
XImg,
loadPage
},
data(){
return{
src:'',
list:[]
}
},
beforeMount(){
this.show_1 = true;
this.src = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1527745997085&di=fa62639b1d121b745c28e5db83f47dc2&imgtype=0&src=http%3A%2F%2Fmvimg1.meitudata.com%2F5654458af11156661.jpg';
this.$http.get(global.host + 'conven/findtitle?comnCode=' + this.$router.history.current.query.communityId + "&serviceType=" + this.$router.history.current.query.serverId + '&moduleType=' + this.$router.history.current.query.moduleId).then(function(res){
let data = res.body.result;
let sizeof = this.list.length;
for(let i = 0 ; i < sizeof ; i++){
this.list.pop();
}
for(let i = 0 ; i < data.length ; i++){
data[i].src = global.imgUrl + data[i].serviceIcon
this.list.push(data[i])
}
this.show_1 = false;
console.log(res)
},function(err){
console.log(err)
})
}
}



// WEBPACK FOOTER //
// ./src/components/convenientComponents/favorite.vue